import { useSearchParams } from 'next/navigation'
import { PRODUCT_LIST_QUERY_PARAMS } from 'product-list/constants/queryParams'
import { RECOMMENDED } from 'product-list/context/ProductListFiltersProvider/constants'
import type {
	FiltersSearchParams,
	SerializedFilters,
} from 'product-list/types/Filters'
import type { OrderMethod } from 'product-list/types/ProductsList'
import { useMemo } from 'react'

export const hasSerializedFiltersApplied = ({
	range,
	order,
	filters,
}: SerializedFilters) => {
	if (range && range.length > 0) {
		return true
	}
	if (order !== RECOMMENDED) {
		return true
	}
	if (filters && filters.length > 0) {
		return true
	}
	return false
}

export function useFiltersSearchParams() {
	const searchParams = useSearchParams()

	const filterSearchParams = useMemo<FiltersSearchParams>(() => {
		const current = new URLSearchParams(Array.from(searchParams.entries()))
		return {
			order:
				(current.get(PRODUCT_LIST_QUERY_PARAMS.order) as OrderMethod) ??
				undefined,
			range: current.get(PRODUCT_LIST_QUERY_PARAMS.range) ?? undefined,
			filters: current.get(PRODUCT_LIST_QUERY_PARAMS.filters) ?? undefined,
		}
	}, [searchParams])

	const hasFiltersApplied = useMemo(
		() => Object.values(filterSearchParams).some(Boolean),
		[filterSearchParams]
	)

	return useMemo(
		() => ({
			hasFiltersApplied,
			filterSearchParams,
		}),
		[hasFiltersApplied, filterSearchParams]
	)
}
